import { Token } from '@uniswap/sdk-core'
import type { GaugeType } from 'uniswap/src/features/transactions/liquidity/steps/claimPositionRewards'
import type { StakeAfterClaimAccumulator } from 'uniswap/src/features/transactions/liquidity/types'
import { OnChainTransactionFields, TransactionStepType } from 'uniswap/src/features/transactions/steps/types'
import { ValidatedTransactionRequest } from '../../swap/utils/trade'

export interface CollectLpIncentiveRewardsTransactionStep extends OnChainTransactionFields {
  type: TransactionStepType.CollectLpIncentiveRewardsTransactionStep
  rewardSymbol?: string
  gauge?: GaugeType
  rewardTokenAddress?: `0x${string}`
  stakeAfterClaimAccumulator?: StakeAfterClaimAccumulator
  isBmxReward?: boolean
  stakeBmxToken?: Token
}

export function createCollectLpIncentiveRewardsStep(
  txRequest: ValidatedTransactionRequest,
  metadata?: {
    rewardSymbol?: string
    gauge?: GaugeType
    rewardTokenAddress?: `0x${string}`
    stakeAfterClaimAccumulator?: StakeAfterClaimAccumulator
    isBmxReward?: boolean
    stakeBmxToken?: Token
  },
): CollectLpIncentiveRewardsTransactionStep {
  return {
    type: TransactionStepType.CollectLpIncentiveRewardsTransactionStep,
    txRequest,
    rewardSymbol: metadata?.rewardSymbol,
    gauge: metadata?.gauge,
    rewardTokenAddress: metadata?.rewardTokenAddress,
    stakeAfterClaimAccumulator: metadata?.stakeAfterClaimAccumulator,
    isBmxReward: metadata?.isBmxReward,
    stakeBmxToken: metadata?.stakeBmxToken,
  }
}
